// Renderiza contenido de texto ENRIQUECIDO (HTML) de forma SEGURA.
//
// El panel del sistema guarda estos campos como HTML (negritas, listas, enlaces, subtítulos).
// Aquí se SANITIZA con DOMPurify antes de inyectarlo (defensa anti-XSS: elimina <script>,
// on*=..., javascript:, etc.). Retrocompatible: un valor de TEXTO PLANO (sin etiquetas, como el
// contenido sembrado hoy) se muestra tal cual, preservando sus saltos de línea.

import React from "react";
import DOMPurify from "dompurify";

function toHtml(value) {
  if (typeof value !== "string") return "";
  const v = value.trim();
  if (v === "") return "";
  // Sin '<' => es texto plano: preserva párrafos (doble salto) y saltos simples (<br>).
  if (v.indexOf("<") === -1) {
    return v
      .split(/\n{2,}/)
      .map((p) => `<p>${p.replace(/\n/g, "<br>")}</p>`)
      .join("");
  }
  return v;
}

export function RichText({ html, className, as: Tag = "div", style }) {
  const clean = DOMPurify.sanitize(toHtml(html), {
    USE_PROFILES: { html: true },
    ADD_ATTR: ["target", "rel"],
  });
  const cls = className ? `rich ${className}` : "rich";
  return <Tag className={cls} style={style} dangerouslySetInnerHTML={{ __html: clean }} />;
}

export default RichText;
